export default __webpack_public_path__ + "static/AzoSansRegular-12d9e6ce264ba788abf2e5d10cab3879.woff2";